// extracted by mini-css-extract-plugin
module.exports = {"container":"_2787e5dfdf--container--AbyY5","label":"_2787e5dfdf--label--_Rxlf","content":"_2787e5dfdf--content--T6jSb"};